import L from "leaflet";
import * as React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { Box } from "@mui/material";
import { titleCase } from "title-case";

const restAreaIcons = {
  open: process.env.PUBLIC_URL + "/mapicons/RestArea/Rest_Area_Open3.png",
  closed: process.env.PUBLIC_URL + "/mapicons/RestArea/Rest_Area_Closed.png",
  unknown: process.env.PUBLIC_URL + "/mapicons/RestArea/Rest_Area_Unknown.png",
};

const getRestAreaIconUrl = (feature) => {
  if (feature.properties.open === "Yes") {
    return restAreaIcons["open"];
  } else if (feature.properties.open === "No") {
    return restAreaIcons["closed"];
  } else {
    return restAreaIcons["unknown"];
  }
};

const restAreaIcon = (feature) =>
  L.icon({
    iconUrl: getRestAreaIconUrl(feature),
    iconSize: [21, 21], // size of the icon
    popupAnchor: [0, 0], // point from which the popup should open relative to the iconAnchor
  });

const getLeafletIcon = (feature, latlng, map, pane) => {
  var title = "  Rest Area - " + getStatus(feature.properties);
  return L.marker(latlng, {
    icon: restAreaIcon(feature),
    title: title,
    alt: title,
    pane: pane,
  });
};

const getStatus = (properties) => {
  return properties.name + " - " + properties.address;
};

const PopupTemplate = (props) => {
  const feature = props.feature;
  return <RestArea feature={feature} />;
};

const RestArea = (props) => {
  const feature = props.feature;
  const properties = feature.properties;
  const avtSrc = getRestAreaIconUrl(feature);
  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardHeader
        avatar={
          <Avatar
            alt="Rest Area"
            src={avtSrc}
            sx={{ width: 21, height: 21 }}
            aria-label="RestArea"
          ></Avatar>
        }
        title={<font className="layer-title"> Rest Area </font>}
        sx={{ pb: 0, paddingTop: 1, paddingLeft: 1 }}
        className={"styledtablerow"}
      />

      <CardContent
        sx={{
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 1,
          paddingRight: 1,
        }}
      >
        <Table size="small">
          <TableRow>
            <TableCell className={"layertablecellLeft"} colSpan={2}>
              <div>{properties.name}</div>
              {`${properties.address}`}
            </TableCell>
          </TableRow>
          <TableRow className={"styledtablerow"}>
            <TableCell className={"layertablecellLeft"}>Description</TableCell>
            <TableCell className={"layertablecellRight"}>
              {properties.description}
            </TableCell>
          </TableRow>
          {(properties.open === "Yes" || properties.open === "No") && (
            <TableRow>
              <TableCell className={"layertablecellLeft"}>Open</TableCell>
              <TableCell className={"layertablecellRight"}>
                {properties.open}
              </TableCell>
            </TableRow>
          )}
        </Table>
      </CardContent>
    </Card>
  );
};

const LegendTemplate = (props) => {
  return (
    <Box sx={{ display: "inline-list-item", height: "50px" }}>
      {Object.keys(restAreaIcons).map((key, index) => {
        let image = restAreaIcons[key];
        return (
          <Box sx={{ ml: 8, mr: -8, display: "inline-list-item" }} key={key}>
            <Box
              sx={{
                backgroundImage: `url(${image})`,
                backgroundSize: "contain",
                width: "20px",
                backgroundRepeat: "no-repeat",
              }}
            ></Box>
            <Box sx={{ mr: 1, ml: 1, fontSize: 12 }}>{titleCase(key)}</Box>
          </Box>
        );
      })}
    </Box>
  );
};

const module = {
  name: "Rest Areas",
  endpoint: "/restAreaMap.json",
  showOnMap: true,
  getLeafletIcon: getLeafletIcon,
  PopupTemplate: PopupTemplate,
  updateDelay: 180,
  mapLayerIcon:
    process.env.PUBLIC_URL + "/mapicons/RestArea/Rest_Area_Open3.png",
  LegendTemplate: LegendTemplate,
  maxZoom: 5,
  zIndex: 615,
};

export default module;
